/**
 * 工作台配置
 * 根据角色定义KPI卡片、待办分类、图表类型和快捷入口
 * 配置值为i18n key字符串，在组件中通过 t(key) 翻译
 *
 * 配色体系：TwinStar 双子星色系（蓝 #2563EB / 绿 #059669 / 靛紫 #7C3AED / 琥珀 #D97706 / 红 #DC2626）
 */

/**
 * 角色对应的KPI卡片配置
 * field: DashboardOverviewVO.KpiData 中的字段名
 */
export const ROLE_KPI_CONFIG = {
  admin: [
    { field: 'signingRate', label: 'dashboard.kpi.signingRate', unit: '%', icon: 'TrendingUp', color: '#2563EB' },
    { field: 'monthlyReceivable', label: 'dashboard.kpi.monthlyReceivable', unit: 'dashboard.kpi.unitYuan', icon: 'DollarSign', color: '#059669' },
    { field: 'collectionRate', label: 'dashboard.kpi.collectionRate', unit: '%', icon: 'PieChart', color: '#7C3AED' },
    { field: 'operatingMerchants', label: 'dashboard.kpi.operatingMerchants', unit: 'dashboard.kpi.unitCount', icon: 'Store', color: '#D97706' }
  ],
  recruitment_manager: [
    { field: 'signingRate', label: 'dashboard.kpi.signingRate', unit: '%', icon: 'TrendingUp', color: '#2563EB' },
    { field: 'activeIntentions', label: 'dashboard.kpi.activeIntentions', unit: 'dashboard.kpi.unitCount', icon: 'FileText', color: '#059669' },
    { field: 'newContractsThisMonth', label: 'dashboard.kpi.newContractsThisMonth', unit: 'dashboard.kpi.unitCount', icon: 'FilePlus', color: '#7C3AED' },
    { field: 'vacantShops', label: 'dashboard.kpi.vacantShops', unit: 'dashboard.kpi.unitCount', icon: 'Building2', color: '#DC2626' }
  ],
  finance_manager: [
    { field: 'monthlyReceivable', label: 'dashboard.kpi.monthlyReceivable', unit: 'dashboard.kpi.unitYuan', icon: 'DollarSign', color: '#2563EB' },
    { field: 'monthlyReceived', label: 'dashboard.kpi.monthlyReceived', unit: 'dashboard.kpi.unitYuan', icon: 'Wallet', color: '#059669' },
    { field: 'collectionRate', label: 'dashboard.kpi.collectionRate', unit: '%', icon: 'PieChart', color: '#7C3AED' },
    { field: 'overdueAmount', label: 'dashboard.kpi.overdueAmount', unit: 'dashboard.kpi.unitYuan', icon: 'AlertTriangle', color: '#DC2626' }
  ],
  operation_manager: [
    { field: 'operatingMerchants', label: 'dashboard.kpi.operatingMerchants', unit: 'dashboard.kpi.unitCount', icon: 'Store', color: '#2563EB' },
    { field: 'renovatingCount', label: 'dashboard.kpi.renovatingCount', unit: 'dashboard.kpi.unitCount', icon: 'Hammer', color: '#D97706' },
    { field: 'openingRate', label: 'dashboard.kpi.openingRate', unit: '%', icon: 'TrendingUp', color: '#059669' },
    { field: 'vacantShops', label: 'dashboard.kpi.vacantShops', unit: 'dashboard.kpi.unitCount', icon: 'Building2', color: '#DC2626' }
  ],
  property_supervisor: [
    { field: 'pendingWorkOrders', label: 'dashboard.kpi.pendingWorkOrders', unit: 'dashboard.kpi.unitCount', icon: 'ClipboardList', color: '#2563EB' },
    { field: 'urgentWorkOrders', label: 'dashboard.kpi.urgentWorkOrders', unit: 'dashboard.kpi.unitCount', icon: 'AlertTriangle', color: '#DC2626' },
    { field: 'todayWorkOrders', label: 'dashboard.kpi.todayWorkOrders', unit: 'dashboard.kpi.unitCount', icon: 'FilePlus', color: '#059669' },
    { field: 'overdueWorkOrders', label: 'dashboard.kpi.overdueWorkOrders', unit: 'dashboard.kpi.unitCount', icon: 'Clock', color: '#D97706' }
  ],
  employee: [
    { field: 'myTaskTotal', label: 'dashboard.kpi.myTaskTotal', unit: 'dashboard.kpi.unitCount', icon: 'ClipboardList', color: '#2563EB' },
    { field: 'myTaskCompleted', label: 'dashboard.kpi.myTaskCompleted', unit: 'dashboard.kpi.unitCount', icon: 'CheckCircle', color: '#059669' },
    { field: 'myTaskDueThisWeek', label: 'dashboard.kpi.myTaskDueThisWeek', unit: 'dashboard.kpi.unitCount', icon: 'Clock', color: '#D97706' },
    { field: 'myCompletionRate', label: 'dashboard.kpi.myCompletionRate', unit: '%', icon: 'BarChart2', color: '#7C3AED' }
  ]
}

/**
 * 待办分类标签
 */
export const TODO_CATEGORIES = [
  { key: 'all', label: 'dashboard.todo.all', icon: 'List' },
  { key: 'overdue', label: 'dashboard.todo.overdue', icon: 'AlertCircle', color: '#DC2626' },
  { key: 'expiring', label: 'dashboard.todo.expiring', icon: 'Clock', color: '#D97706' },
  { key: 'approval', label: 'dashboard.todo.approval', icon: 'FileCheck', color: '#2563EB' },
  { key: 'rejected', label: 'dashboard.todo.rejected', icon: 'XCircle', color: '#64748B' },
  { key: 'task', label: 'dashboard.todo.task', icon: 'ClipboardList', color: '#059669' }
]

/**
 * 角色对应的快捷入口
 */
export const ROLE_QUICK_ACTIONS = {
  admin: [
    { label: 'dashboard.quick.merchantWorkbench', icon: 'LayoutDashboard', route: '/merchant/workbench' },
    { label: 'dashboard.quick.contractManage', icon: 'FileText', route: '/contract/rent' },
    { label: 'dashboard.quick.billingManage', icon: 'DollarSign', route: '/payment/billing' },
    { label: 'dashboard.quick.renovationManage', icon: 'Hammer', route: '/operation/renovation' }
  ],
  recruitment_manager: [
    { label: 'dashboard.quick.merchantWorkbench', icon: 'LayoutDashboard', route: '/merchant/workbench' },
    { label: 'dashboard.quick.policyManage', icon: 'ScrollText', route: '/merchant/policy' },
    { label: 'dashboard.quick.contractManage', icon: 'FileText', route: '/contract/rent' },
    { label: 'dashboard.quick.brandLibrary', icon: 'Tag', route: '/merchant/brand' }
  ],
  finance_manager: [
    { label: 'dashboard.quick.billingManage', icon: 'DollarSign', route: '/payment/billing' },
    { label: 'dashboard.quick.contractManage', icon: 'FileText', route: '/contract/rent' },
    { label: 'dashboard.quick.feeEntry', icon: 'Receipt', route: '/payment/feeEntry' },
    { label: 'dashboard.quick.financeReport', icon: 'BarChart2', route: '/report/finance/revenue' }
  ],
  operation_manager: [
    { label: 'dashboard.quick.renovationManage', icon: 'Hammer', route: '/operation/renovation' },
    { label: 'dashboard.quick.salesReport', icon: 'BarChart2', route: '/operation/sales' },
    { label: 'dashboard.quick.merchantWorkbench', icon: 'LayoutDashboard', route: '/merchant/workbench' },
    { label: 'dashboard.quick.contractManage', icon: 'FileText', route: '/contract/rent' }
  ],
  property_supervisor: [
    { label: 'dashboard.quick.workorderManage', icon: 'ClipboardList', route: '/tenant/workorder' },
    { label: 'dashboard.quick.createWorkorder', icon: 'FilePlus', route: '/tenant/workorder?action=create' }
  ],
  employee: [
    { label: 'dashboard.quick.merchantWorkbench', icon: 'LayoutDashboard', route: '/merchant/workbench' },
    { label: 'dashboard.quick.contractManage', icon: 'FileText', route: '/contract/rent' },
    { label: 'dashboard.quick.billingManage', icon: 'DollarSign', route: '/payment/billing' },
    { label: 'dashboard.quick.renovationManage', icon: 'Hammer', route: '/operation/renovation' }
  ]
}

/**
 * 通知类型配置
 */
export const NOTIFICATION_TYPES = [
  { key: 'all', label: 'dashboard.notification.typeAll' },
  { key: 'BUSINESS', label: 'dashboard.notification.typeBusiness' },
  { key: 'APPROVAL', label: 'dashboard.notification.typeApproval' },
  { key: 'SYSTEM', label: 'dashboard.notification.typeSystem' }
]
